import module from './module.js'
// Components
import './components/cajaAhorro/aportaciones/component.js'
import './components/cajaAhorro/aportaciones/agregar/component.js'
import './components/cajaAhorro/aportaciones/confirmar/component.js'
import './components/cajaAhorro/aportaciones/elemento/component.js'
import './components/cajaAhorro/aportaciones/formulario/component.js'
import './components/cajaAhorro/aportaciones/item/component.js'
import './components/cajaAhorro/prestamos/component.js'
import './components/cajaAhorro/prestamos/agregar/component.js'
import './components/cajaAhorro/prestamos/agregar/amortizacion/component.js'
import './components/cajaAhorro/prestamos/confirmacion/component.js'
import './components/cajaAhorro/prestamos/item/component.js'
import './components/cajaAhorro/prestamos/item/amortizacion/component.js'
import './components/incapacidades/component.js'
import './components/incapacidades/agregar/component.js'
import './components/incapacidades/editar/component.js'
import './components/incapacidades/eliminar/component.js'
import './components/incapacidades/incapacidad/component.js'
import './components/incapacidades/lista/component.js'
import './components/incapacidades/lista/item/component.js'
import './components/prestamosExternos/component.js'
import './components/prestamosExternos/credito/component.js'
import './components/prestamosExternos/confirmar/component.js'
import './components/prestamosExternos/agregar/component.js'
import './components/prestamosExternos/item/component.js'
import './components/prestamosExternos/prestamo/plazos/component.js'
import './components/prestamosExternos/prestamo/component.js'
import './components/prestamosExternos/eliminar/component.js'
import './components/prestamosExternos/eliminar/confirmar/component.js'
// Routes
import './routes/CajaAhorro.js'
// Services
import './services/Colaborador.js'
import './services/Colaborador/Incapacidad.js'
import './services/Colaborador/CajaAhorro.js'
import './services/Colaborador/CajaAhorros.js'
import './services/Colaborador/CajaAhorro/Aportaciones.js'
import './services/Colaborador/CajaAhorro/Concluir.js'
import './services/Colaborador/CajaAhorro/Prestamo/Periodicidad.js'
import './services/Colaborador/CajaAhorro/Prestamo.js'
import './services/Colaborador/CajaAhorro/Prestamos.js'
import './services/Colaborador/CajaAhorro/Beneficiarios.js'
import './services/Colaborador/Incapacidades.js'
import './services/Colaborador/PrestamosExternos.js'
import './services/Colaborador/PrestamoExterno.js'
import './services/Colaborador/PrestamosExternos/Credito.js'

import './services/Catalogos/Persona'

export default module.name



// WEBPACK FOOTER //
// ./src/colaborador/index.js